import { Controller } from "@hotwired/stimulus";

const KEY = "theme"; // "dark" | "light"

export default class extends Controller {
    static targets = ["sun", "moon"];

    connect() {
        // ustaw stan ikon przy starcie
        this.updateIcons();
    }

    toggle() {
        const root = document.documentElement; // <html>
        const isDark = root.classList.toggle("dark"); // przełącz klasę
        try {
            localStorage.setItem(KEY, isDark ? "dark" : "light");
        } catch (_) {}
        this.updateIcons();
    }

    updateIcons() {
        const isDark = document.documentElement.classList.contains("dark");
        if (this.hasSunTarget)  this.sunTarget.classList.toggle("hidden", !isDark);
        if (this.hasMoonTarget) this.moonTarget.classList.toggle("hidden", isDark);
    }
}
